import { Link, useLocation } from "react-router-dom";
import { FaChartLine } from "react-icons/fa";
import { BsList } from "react-icons/bs";

const ALLOWED_ROLES = ["manager"];
const NAV_ROLES = ["admin", "director", "manager", "print"];

// Куда возвращаться при клике из Dashboard для каждой роли
const HOME_PATH = {
  manager: "/",
};

export const DashboardNavButton = ({ userRole }) => {
  const location = useLocation();
  const isOnDashboard = location.pathname === "/dashboard";

  if (!ALLOWED_ROLES.includes(userRole)) {
    return <div className="flex items-center w-[12%]"></div>;
  }

  return (
    <div className="flex items-center w-[12%] justify-center pr-4">
      {NAV_ROLES.includes(userRole) && (
        <Link
          to={isOnDashboard ? HOME_PATH[userRole] : "/dashboard"}
          title={isOnDashboard ? "Manager list" : "Dashboard"}
        >
          {isOnDashboard ? (
            <BsList className="text-[40px] text-[#739D00] hover:text-[#739d00a8]" />
          ) : (
            <FaChartLine className="text-[30px] text-[#739D00] hover:text-[#739d00a8]" />
          )}
        </Link>
      )}
    </div>
  );
};
